import { createFileRoute } from '@tanstack/react-router';
import { HomeRedirect } from '@/features/debts/home-redirect.js';

/**
 * The app root forwards to the first page of the navigation the user may open
 * (debts.md section 4).
 */
export const Route = createFileRoute('/_app/')({
  component: HomeRedirect,
});
